module.exports = __webpack_public_path__ + "static/media/W4.38cc0018.jpg";